exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trip-display-title {\r\n    font-size: 2em;\n}\r\n", ""]);

// exports
